module.exports = __webpack_public_path__ + "static/Anbaugebiet-Nahe-800x946-4c409c72922df76dbfa83c25e3788b20.jpeg";